export const APP_URLS = {
  ROOT(): any[] {
    return ['/'];
  },
} as const;
